import axiosInstance from "./axios";

export const initializeWorkoutDayRequest = async () =>
  axiosInstance
    .get("/clients/initialize-workout-day")
    .then((response) => response.data);

export const getWorkoutDayRequest = async () =>
  axiosInstance
    .get("/clients/get-client-workout-day")
    .then((response) => response.data);

export const warmUpExercisesFetcher = async (clientDataId) =>
  axiosInstance
    .get("/clients/client-warm-up-exercises-handler", {
      params: { clientDataId },
    })
    .then((response) => response.data);

export const strengthExercisesFetcher = async (workoutSplit, clientDataId) =>
  axiosInstance
    .get("/clients/strength-exercises-handler", {
      params: {
        workoutSplit,
        clientDataId,
      },
    })
    .then((response) => response.data);

export const workoutProgramCommentFetcher = async (clientDataId) =>
  axiosInstance
    .get("/clients-accounts-experiences/workout-plan-comment", {
      params: {
        clientDataId,
      },
    })
    .then((response) => response.data);

export const supersetsFetcher = async (workoutSplit, clientDataId) =>
  axiosInstance
    .get("/clients/supersets-exercises-handler", {
      params: {
        workoutSplit,
        clientDataId,
      },
    })
    .then((response) => response.data);

export const cardioExercisesFetcher = async (clientDataId) =>
  axiosInstance
    .get("/clients/cardio-exercises-handler", { params: { clientDataId } })
    .then((response) => response.data);

export const staticStretchesFetcher = async (clientDataId) =>
  axiosInstance
    .get("/clients/static-stretches-handler", { params: { clientDataId } })
    .then((response) => response.data);

export const recordExerciseRequest = async (requestData) =>
  axiosInstance
    .post("/clients/exercise-record-handler", requestData)
    .then((response) => response.data);

export const exerciseRecordsFetcher = async (exerciseId) =>
  axiosInstance
    .get("/clients/exercise-record-handler", {
      params: {
        exerciseId,
      },
    })
    .then((response) => response.data);

export const proceedWorkoutDayRequest = async (clientDataId) =>
  axiosInstance
    .get("/clients/proceed-workout-day", { params: { clientDataId } })
    .then((response) => response.data);

export const resetWorkoutRoutineRequest = async () =>
  axiosInstance
    .get("/clients/reset-workout-routine")
    .then((response) => response.data);

export const exerciseLatestRecordFetcher = async (exerciseId, setIndex) =>
  axiosInstance
    .get("/clients/exercise-latest-record-handler", {
      params: { exerciseId, setIndex },
    })
    .then((response) => response.data);

export const exerciseRecordAdder = async (requestData) =>
  axiosInstance
    .post("/clients/exercise-latest-record-handler", requestData)
    .then((response) => response.data);

export const workoutPlanCalendarFetcher = async (clientDataId) =>
  axiosInstance
    .get("/clients/workout-plan-calendar-handler", {
      params: {
        clientDataId,
      },
    })
    .then((response) => response.data);

export const proceeedToSelectedWorkoutDayRequest = async (
  calendarDayId,
  clientDataId
) =>
  axiosInstance
    .get("/clients/proceed-to-selected-workout-day-handler", {
      params: {
        calendarDayId,
        clientDataId,
      },
    })
    .then((response) => response.data);
